import React from "react";
import { PropTypes } from "prop-types";

import { NAVBAR_HEIGHT } from "./Navbar";
import {
  STEPS,
  LIFE_CYCLE_COST_STEPPER_STEPS_ORDER,
  CAP_X_STEPPER_STEPS_ORDER,
} from "../constants/stepsConstants";
import { BOTTOM_BAR_HEIGHT } from "./BottomBar";
import ProgressStepper from "./ProgressStepper";
import { EVALUATION_TYPES } from "../constants/storageConstants";

export default function StepContainer({
  activeStep,
  children,
  evaluationType,
  withProgressStepper = true,
}) {
  const getStepperSteps = () => {
    if (evaluationType === EVALUATION_TYPES.LIFE_CYCLE_COST) {
      return LIFE_CYCLE_COST_STEPPER_STEPS_ORDER;
    }

    if (evaluationType === EVALUATION_TYPES.CAP_X)
      return CAP_X_STEPPER_STEPS_ORDER;
    throw new Error(`Invalid evaluation type: ${evaluationType}`);
  };

  return (
    <div
      data-testid="StepContainer"
      style={{
        display: "flex",
        height: `calc(100% - ${NAVBAR_HEIGHT}px)`,
      }}
    >
      {withProgressStepper && (
        <ProgressStepper
          activeStep={activeStep}
          steps={getStepperSteps()}
          withLinks
        />
      )}
      <div
        style={{
          height: "100%",
          position: "relative",
          width: "100%",
        }}
      >
        <div
          style={{
            maxHeight: `calc(100% - ${BOTTOM_BAR_HEIGHT}px)`,
            overflowY: "auto",
          }}
        >
          <div style={{ padding: "20px" }}>{children}</div>
        </div>
      </div>
    </div>
  );
}

StepContainer.propTypes = {
  activeStep: PropTypes.oneOf(Object.values(STEPS)),
  children: PropTypes.node.isRequired,
  evaluationType: PropTypes.oneOf(Object.values(EVALUATION_TYPES)),
  withProgressStepper: PropTypes.bool,
};
